export const FETCH_MONITORING_HISTORIES = 'video-lecture/FETCH_MONITORING_HISTORIES';
export const UPDATE_MONITORING_HISTORY = 'video-lecture/UPDATE_MONITORING_HISTORY';



// WEBPACK FOOTER //
// ./src/app/video-lecture/store/mutation-types.js